<template>
  <div>
    <div class="clearfix"></div>
    <div class="row">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class role="tabpanel">
          <ul id="ticketTabs" class="nav nav-tabs bar_tabs pull-right" role="tablist">
            <li role="presentation">
              <a href="#overviewTab" data-toggle="tab" class="active">
                <i class="fas fa-table"></i> Overview
              </a>
            </li>
            
            <li
              role="presentation"
              :class="{'animated bounce infinite bold loadedFileActive': loadedTicketStatus }"
            >
              <a href="#detailTab" data-toggle="tab" @click="loadedTicketStatus = false">
                <i class="fas fa-info-circle"></i>
                Ticket details {{ loadedTicketId }}
              </a>
            </li>
            <li role="presentation">
              <a href="#createTab" data-toggle="tab">
                <i class="fas fa-plus"></i> Create
              </a>
            </li>
          </ul>
          <div id="ticketTabContent" class="tab-content">
            <div class="tab-pane active" id="overviewTab">
              <!--- Left panel with open files -->
              <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="card">
                  <div class="card-content">
                    <v-server-table :url="dataUrl" :columns="tableColumns" ref="ticketTable">
                      <template
                        slot="customer"
                        slot-scope="props"
                      >{{ props.row.customer }} {{ props.row.customer_lastname}}</template>
                      <template slot="status" slot-scope="props">
                        <span v-if="props.row.status == 'new'">
                          <i class="fas fa-asterisk text-pending"></i> New
                        </span>
                        <span v-if="props.row.status == 'open'">
                          <i class="fas fa-clock text-pending"></i> Open
                        </span>
                        <span v-if="props.row.status == 'closed'">
                          <i class="fas fa-window-close text-success"></i> Closed
                        </span>
                      </template>
                      <template slot="actions" slot-scope="props">
                        <div class="tableAction">
                          <a class="btn btn bg-blue" @click="editRow(props.row.id)">
                            <i class="fas fa-edit"></i>
                          </a>
                          <a
                            v-if="!props.row.deleted"
                            class="btn bg-orange"
                            @click="deleteRow(props.row.id)"
                            data-tooltip="Delete ticket"
                          >
                            <i class="fa fa-trash"></i>
                          </a>
                        </div>
                      </template>
                    </v-server-table>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Ticket details -->
            <div class="tab-pane" id="detailTab">
              <ticket
                :ticketId="loadedTicketId"
                ref="ticketEditor"
                :loadedTicketId.sync="loadedTicketId"
                :loadedTicketStatus.sync="loadedTicketStatus"
                v-on:ticketSaved="reloadTable()"
              ></ticket>
            </div>
            <!-- Ticket create -->
            <div class="tab-pane" id="createTab">
              CREATE
              <new-ticket
                ref="ticketCreator"
                v-on:ticketSaved="reloadTable()"
              ></new-ticket>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Ticket from "../../components/ticket";
import NewTicket from "../../components/newticket";
export default {
  components: {
    Ticket,
    NewTicket
  },
  data: function() {
    return {
      openTicketOnLoadId: this.$route.params.ticketId,
      loadedTicketStatus: false,
      loadedTicketId: "",
      dataUrl: APIURL + "/tickets",
      options: {
        perPage: 10,
        headings: {}
      },
      tableColumns: ["id", "status", "subject", "created_at", "actions"],
      allTableColumns: ["id", "status", "subject", "created_at", "actions"]
    };
  },
  mounted: function() {
    return axios
      .get(APIURL + "/tickets")
      .then(response => {
      })
      .catch(function(e) {
        console.log(e);
      });
    if (this.openFileOnLoadId) {
      this.editRow(this.openFileOnLoadId);
      $('.nav-tabs a[href="#detailTab"]').tab("show");
    }
  },
  methods: {
    reloadTable() {
      this.$refs.ticketTable.getData();
      $("html, body").animate({ scrollTop: 0 }, "fast");
      this.loadedTicketStatus = false;
      $('.nav-tabs a[href="#overviewTab"]').tab("show");
    },
    editRow(id) {
      this.loadedTicketStatus = true;
      var ticketEditor = this.$refs.ticketEditor;
      this.fileLoaded = "untouched";
      this.loadedTicketId = id;
      ticketEditor.loadTicketDetails(id);
      $('.nav-tabs a[href="#detailTab"]').tab("show");
    },
    deleteRow(id) {
      swal({
        title: "Are you sure?",
        text:
          "This ticket will be closed and be forgotten forever!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result) {
          Webservice.deleteTicket(id)
            .then(resp => {
                if (resp) {
                  swal("Deleted!", "Ticket has been deleted.", "success");
                  this.$refs.ticketTable.refresh();
                  return;
                }
              }
            )
            .catch(error => {
              toastr.warning(
                "Couldn't remove ticket. Please try again later - message:" +
                  error.message,
                "Oops!"
              );
            });
        }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Tickets/Overview.vue